import React, { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import DashboardLayout from "./DashboardLayout";
import DateObject from "react-date-object";
import persian from "react-date-object/calendars/persian";
import { getComplaintDetails } from "../services/ComplaintsService";
import { CustomerContext } from "../context/customerContext";

const ComplaintsDetails = () => {
  const { requestNo } = useParams(); // دریافت شماره شکایت از URL
  const navigate = useNavigate();
  const [complaint, setComplaint] = useState(null);
  const { customer } = useContext(CustomerContext);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchComplaint = async () => {
      try {
        const response = await getComplaintDetails(requestNo);
        setComplaint(response.data);
      } catch (error) {
        console.error("❌ خطا در دریافت اطلاعات:", error);
      } finally {
        setLoading(false);
      }
    };

    if (requestNo) {
      fetchComplaint();
    }
  }, [requestNo]);

  const formatDateToPersian = (date) =>
    new DateObject({ date, calendar: "gregorian" })
      .convert(persian)
      .format("YYYY/MM/DD");

  if (loading || !complaint) {
    return (
      <DashboardLayout>
        <div className="p-6 text-blue-700 text-center">
          در حال بارگذاری جزئیات اعلانات و شکایات...
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <div className="mt-6 p-6 bg-white rounded-xl shadow-lg space-y-6" dir="rtl">
        {/* هدر صفحه */}
        <div className="flex justify-between items-center border-b pb-3">
          <h2 className="text-base sm:text-lg md:text-xl font-bold text-blue-700">
            جزئیات شکایت
          </h2>
          <button
            onClick={() => navigate(-1)}
            className="px-3 py-1 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded"
          >
            بازگشت
          </button>
        </div>

        {/* اطلاعات اصلی شکایت */}
        <div className="space-y-2 bg-blue-50 text-blue-900 px-5 py-4 rounded-md border border-blue-100 shadow-sm">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-1">
            <p>
              شماره شکایت: <strong>{complaint.requestNo}</strong>
            </p>
            <p>
              تاریخ ثبت: <strong>{formatDateToPersian(complaint.date)}</strong>
            </p>
          </div>
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-1">
            <p>
              نام مشتری: <strong>{customer?.customerName}</strong>
            </p>
            <p>
              کد مشتری: <strong>{customer?.customerCode}</strong>
            </p>
          </div>
        </div>

        {/* شرح شکایت + وضعیت بررسی */}
        <div className="bg-gray-50 border rounded px-4 py-3 text-sm leading-relaxed break-words">
          <div className="mb-2 text-gray-800 font-semibold">
            وضعیت بررسی:{" "}
            <span className="text-red-600 font-bold">
              {complaint.complaintStatusName}
            </span>
          </div>
          <div>
            <strong className="block mb-1 text-gray-600">شرح شکایت:</strong>
            <p>{complaint.request || "ثبت نشده"}</p>
          </div>
        </div>

        {/* پاسخ شکایت (در صورت وجود) */}
        {complaint.result && (
          <div className="bg-green-50 border border-green-200 rounded px-4 py-3 text-sm leading-relaxed break-words">
            <strong className="block mb-2 text-green-800">پاسخ:</strong>
            {complaint.result}
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default ComplaintsDetails;
